module.exports = __webpack_public_path__ + "img/inu_gallery6.e62277d5.jpg";